import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'src/app/_services/alert.service';
import { moreThanOneWhiteSpaceValidator } from 'src/app/common/common.validators';
import { MerchantService } from '../../merchants/merchant-master/merchant.service';
import { Router } from '@angular/router';
import { CountryMasterService } from '../../fraud-prevention/country-master-rule/country-master-service';
import { ScreeningUtilityService } from '../screening-utility-service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-screening-utility-add',
  templateUrl: './screening-utility-add.component.html',
  styleUrls: ['./screening-utility-add.component.scss']
})
export class ScreeningUtilityAddComponent implements OnInit {


  utilityForm !: FormGroup;
  utilityFormShufti !: FormGroup;
  utilityFormDigi !: FormGroup;
  submitted = false;
  display = false;
  Resultdata: any;
  merchantId: any;
  currentDate: any = new Date();
  sliderValueTemp: any = 0;
  sliderValue: any = 0;
  countryDropdown: any[];
  finalSearchList: any[];
  searchListDropdown: any[];
  searchListDigiDropdown : any[];
  serviceProvider: any;
  selectedBusinessType: string = 'individual';

  constructor(private formBuilder: FormBuilder, private screeningService: MerchantService, private alertService: AlertService, private router: Router, private countryService: CountryMasterService, private utilityService: ScreeningUtilityService) {

  }
  ngOnInit() {

    this.utilityForm = this.formBuilder.group({

      fullname: ['', [Validators.required, moreThanOneWhiteSpaceValidator(), Validators.pattern("[a-zA-Zé‘’().,&'\\s\\-]+")]],
      // emailId :['',[Validators.required,Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
      // gender :['',Validators.required],
      // dateOfBirth :['',Validators.required],
      // nationality :['',Validators.required],
      // countryOfResidence :['',Validators.required],
      // emiratesId :['',[Validators.required]],
      // emiratesExpiry :['',Validators.required],
      // passportNumber :['',[Validators.required]],
      // passportExpiry :['',Validators.required],
      // address :['',[Validators.required]],
      // state :['',Validators.required],
      // city :['',Validators.required],
      // poBox :['',[Validators.required, moreThanOneWhiteSpaceValidator(),Validators.pattern("^[0-9]{5,6}$")]],
      // contactNumber :['',[Validators.required,Validators.pattern("^[0-9]{9,10}$")]],
      emailId: ['', [Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
      gender: [null],
      dateOfBirth: [''],
      nationality: [null],
      countryOfResidence: [null],
      emiratesId: [''],
      emiratesExpiry: [''],
      passportNumber: [''],
      passportExpiry: [''],
      address: [''],
      state: [null],
      city: [''],
      poBox: ['', [Validators.pattern("^[0-9]{5,6}$")]],
      contactNumber: ['', [, Validators.pattern("^[0-9]{9,10}$")]],

    })

    this.utilityFormShufti = this.formBuilder.group({
      fullname: ['', [Validators.required, moreThanOneWhiteSpaceValidator(), Validators.pattern("[a-zA-Zé‘’().,&'\\s\\-\u0621-\u064A\u0660-\u0669]+")]],
      dateOfBirth: [''],
      nationality: [null],
      aliasCheck: [''],
      rcaCheck: [''],
    })

    this.utilityFormDigi = this.formBuilder.group({
      fullname: ['', [Validators.required, moreThanOneWhiteSpaceValidator(), Validators.pattern("[a-zA-Zé‘’().,&'\\s\\-\u0621-\u064A\u0660-\u0669]+")]],
      dateOfBirth: [''],
      nationality: [null],
    })

    this.countryService.getCountryListAll("", "", "", "", "ALL", 0).subscribe((response: any) => {
      console.log(response);
      if(response && response.response && response.response.data && response.response.data.content){
        this.countryDropdown = response.response.data.content.map( (_ : any) => {
          return {
            name: _.name,
            code: _.code
          }
        });    
      }
    })

    this.finalSearchList = [];
    // this.searchListDropdown = ["sanction", "warning", "fitness-probity", "pep", "pep-class-1", "pep-class-2", "pep-class-3", "pep-class-4","adverse-media"];
    this.searchListDropdown =
      [{ key: "sanction", title: "Sanctions", isSelectedALL: 'ALL' },
      { key: "SIP", title: "(Special Interest Person) SIP", isSelectedALL: 'ALL' },
      { key: "SIE", title: "(Special Interest Entity) SIE", isSelectedALL: 'ALL' },
      { key: "warning", title: "Warnings", isSelectedALL: 'ALL' },
      { key: "Insolvency", title: "Insolvency", isSelectedALL: 'ALL' },
      { key: "fitness-probity", title: "Fitness-Probity", isSelectedALL: 'ALL' },
      { key: "pep", title: "PEP", isSelectedALL: 'ALL' },
      { key: "pep-class-1", title: "PEP-Class-1", isSelectedALL: 'ALL' },
      { key: "pep-class-2", title: "PEP-Class-2", isSelectedALL: 'ALL' },
      { key: "pep-class-3", title: "PEP-Class-3", isSelectedALL: 'ALL' },
      { key: "pep-class-4", title: "PEP-Class-4", isSelectedALL: 'ALL' },
      { key: "adverse-media", title: "Adverse-Media", isSelectedALL: 'ALL' }
      ]
    console.log(this.currentDate)
    this.currentDate = new Date(this.currentDate.getTime() - 24 * 60 * 60 * 1000);
    console.log(this.currentDate);
     this.searchListDigiDropdown = [{ key: "PEP", title: "PEP", isSelectedALL: 'ALL' },
      { key: "POI", title: "POI", isSelectedALL: 'ALL' },
      { key: "REL", title: "REL", isSelectedALL: 'ALL' },
      { key: "RRE", title: "RRE", isSelectedALL: 'ALL' },
      { key: "INS", title: "INS", isSelectedALL: 'ALL' }];
  }

  changeServiceProvider(sp:any){
    console.log(sp)
    this.finalSearchList = [];
    this.sliderValueTemp= 0;
    this.sliderValue = 0;
  }

  submitIdenfo(data: any) {
    this.submitted = true
    console.log("Screening Data  :" + JSON.stringify(data));
    if (this.utilityForm.valid) {
      // const parentDataTest=" ";
      console.log("Fullname :" + data.fullname);
      console.log("Inside Function");
      const screeningObj: any = {
        "fullname": data.fullname || '',
        "emailId": data.emailId || '',
        "gender": data.gender || '',
        "dateOfBirth": data.dateOfBirth || '',
        "nationality": data.nationality || [],
        "countryOfResidence": data.countryOfResidence || '',
        "emiratesId": data.emiratesId || '',
        "emiratesExpiry": data.emiratesExpiry || '',
        "passportNumber": + data.passportNumber || '',
        "passportExpiry": data.passportExpiry || '',
        "address": data.address || '',
        "city": data.city || '',
        "state": data.state || '',
        "poBox": data.poBox || '',
        "contactNumber": data.contactNumber || '',

      };

      console.log("Final Data ::", screeningObj);
      this.screeningService.createScreeningUtility(screeningObj).subscribe((result) => {
        console.log("API Calling for creating screening utility request : ", result);
        this.alertService.successAlert(result);
        this.router.navigate(['/screeningUtility']);



      });


    }
    console.log("Not Valid");

  }

  submitShufti(data: any) {
    this.submitted = true
    console.log(this.serviceProvider);
    console.log(data);
    console.log(this.sliderValue);
    if (this.utilityFormShufti.valid) {
      console.log("Valid");
      if (this.finalSearchList.length == 0) {
        this.alertService.toastWarringMessageAlertWithMessage("Please select search list");
        return;
      }
      if (this.sliderValue > 100) {
        this.alertService.toastWarringMessageAlertWithMessage("Please set match score below 100");
        return;
      }
      if (this.sliderValue <= 0) {
        this.alertService.toastWarringMessageAlertWithMessage("Please set match score above 0");
        return;
      }
      if (!data.aliasCheck) {
        data.aliasCheck = false;
      }
      if (!data.rcaCheck) {
        data.rcaCheck = false;
      }
      if (data.nationality == null) {
        data.nationality = [];
      }
      console.log(data);
      let requestForm = {};
      if(this.selectedBusinessType === "individual"){
        requestForm = {
          "fullName": data.fullname,
          "screeningType": this.selectedBusinessType,
          "dateOfBirth": data.dateOfBirth,
          "country": data.nationality,
          "matchScore": this.sliderValue,
          "aliasSearch": data.aliasCheck,
          "rcaSearch": data.rcaCheck,
          "searchList": this.finalSearchList,
          "screeningProviderCode": this.serviceProvider
        }
      }else{
        requestForm = {
          "fullName": data.fullname,
          "screeningType": this.selectedBusinessType,
          "matchScore": this.sliderValue,
          "aliasSearch": data.aliasCheck,
          "rcaSearch": data.rcaCheck,
          "searchList": this.finalSearchList,
          "screeningProviderCode": this.serviceProvider
        }
      }
      
      console.log(JSON.stringify(requestForm));
      //API call
      this.utilityService.sendScreeningRequestShuftiPro(requestForm).subscribe((response:any)=>{
        console.log(response);
        if(response.response.message == "Screening Utility request send successfully"){
          Swal.fire('Screening request sent successfully','','success');
          this.router.navigate(['/screeningUtility']);
        }else{
          Swal.fire('Error while sending the request for screening','','error');
          this.router.navigate(['/screeningUtility']);
        }
      })
    } else {
      console.log("Not Valid");
    }
  }

  submitDigi(data:any){
    console.log(JSON.stringify(data))
    this.submitted = true
    console.log(this.serviceProvider);
    console.log(data);
    console.log(this.sliderValue);
    if (this.utilityFormDigi.valid) {
      console.log("Valid");
      if (this.finalSearchList.length == 0) {
        this.alertService.toastWarringMessageAlertWithMessage("Please select search list");
        return;
      }
      if (this.sliderValue > 100) {
        this.alertService.toastWarringMessageAlertWithMessage("Please set match score below 100");
        return;
      }
      if (this.sliderValue <= 0) {
        this.alertService.toastWarringMessageAlertWithMessage("Please set match score above 0");
        return;
      }
      if (data.nationality == null) {
        data.nationality = [];
      }
      let requestForm = {};
      if(this.selectedBusinessType === "individual"){
        requestForm = {
          "fullName": data.fullname,
          "screeningType": this.selectedBusinessType,
          "dateOfBirth": data.dateOfBirth,
          "country": data.nationality,
          "matchScore": this.sliderValue,
          "searchList": this.finalSearchList,
          "screeningProviderCode": this.serviceProvider
        }
      }else{
        requestForm = {
          "fullName": data.fullname,
          "screeningType": this.selectedBusinessType,
          "matchScore": this.sliderValue,
          "searchList": this.finalSearchList,
          "screeningProviderCode": this.serviceProvider
        }
      }
      
      console.log(JSON.stringify(requestForm));
      //API call
      this.utilityService.sendScreeningRequestDigi(requestForm).subscribe((response:any)=>{
        console.log(response);
        if(response.response.message == "Screening Utility request send successfully"){
          Swal.fire('Screening request sent successfully','','success');
          this.router.navigate(['/screeningUtility']);
        }else{
          Swal.fire('Error while sending the request for screening','','error');
          this.router.navigate(['/screeningUtility']);
        }
      })
    } else {
      console.log("Not Valid");
    }
  }

  OnlyNumbersAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    return (charCode > 47 && charCode < 58);

  }

  valueChanged(event: any) {
    console.log(event);
    this.sliderValue = event.target.value;
  }

  inputChange(event: any) {
    if (event.target.value == "") {
      console.log(event.target.value);
      this.sliderValueTemp = 0;
      return;
    }
    if (Number(event.target.value) <= 100) {
      console.log(event.target.value);
      this.sliderValue = event.target.value;
      this.sliderValueTemp = event.target.value;
      return;
    } else if (Number(event.target.value) > 100) {
      console.log(event.target.value);
      this.sliderValueTemp = 0;
      this.sliderValue = 0;
      console.log(this.sliderValue);
      return;
    }

  }

  removeSearchName(event: any) {
    // console.log(event.value);
    // for(let i:number=0;i<this.finalSearchList.length;i++){
    //   if(this.finalSearchList[i] == event.value){
    //     console.log(this.finalSearchList[i]);
    //     this.finalSearchList.splice(i,1);
    //   }
    // }
    console.log(this.finalSearchList);
  }

  addSearchName(event: any) {
    //  console.log(event);
    // this.finalSearchList.push(event);
    console.log(this.finalSearchList);
  }

  // changeScreenType() {
  //   debugger
  //   // Conditionally set the regex based on selectedBusinessType
  //   let regEx = this.selectedBusinessType === "individual"
  //     ? "^[a-zA-Zé‘’().,&'\\\\s]+$" // Individual pattern, no numbers
  //     : "^[a-zA-Zé‘’().,&'\\\\s0-9]+$";

  //   // Now you can use this regex in a form control validator
  //   this.utilityForm.get('fullname')!.setValidators(null);
  //   setTimeout(() => {
  //     this.utilityForm.get('fullname')!.setValidators([Validators.required, moreThanOneWhiteSpaceValidator(), Validators.pattern(regEx)]);
  //     this.utilityForm.get('fullname')!.updateValueAndValidity();
  //   }, 10);

  //   // let regEx = this.selectedBusinessType === "individual" ? "[a-zA-Zé‘’().,&'\\s]+" : "^[a-zA-Zé‘’().,&'\\s0-9]+$";
  //   // let updatedValidators = [Validators.required, moreThanOneWhiteSpaceValidator(), Validators.pattern(regEx)]
  //   // let fullNameControl: any = this.utilityForm.get('fullname');
  //   // debugger
  //   // fullNameControl.setValidators(updatedValidators);
  //   // fullNameControl.updateValueAndValidity();
  // }
  changeScreenType() {
    // Conditionally set the regex based on selectedBusinessType
    let regEx = this.selectedBusinessType === "individual"
      // ? /^[a-zA-Zé‘’().,&'\s]+$/  // Individual pattern (no numbers)
      // : /^[a-zA-Zé‘’().,&'\s0-9]+$/;  // Non-individual pattern (includes numbers)

      ?/^[a-zA-Zé‘’().,&'\s\-\u0621-\u064A\u0660-\u0669]+$/  // Individual pattern (no numbers)
      : /^[a-zA-Z0-9é‘’().,&'\s\-\u0621-\u064A\u0660-\u0669]+$/;  // Non-individual pattern (includes numbers)
  
    // Remove any existing validators and add new ones
    this.utilityFormShufti.get('fullname')!.setValidators([
      Validators.required,  // Check if value is required
      moreThanOneWhiteSpaceValidator(),  // Ensure custom validator is applied
      Validators.pattern(regEx)  // Apply the regex pattern dynamically
    ]);
  
    // Update form control's validity
    this.utilityFormShufti.get('fullname')!.updateValueAndValidity();
  }
  
  

}
